import { MyContentViewsMixin } from '@/app/private/my-content/mixins/my-content-views.mixin';
import { Mixins, Component } from 'vue-property-decorator';

@Component({
  name: 'purchased'
})
export default class Purchased extends Mixins(MyContentViewsMixin) {
  public page: string = 'purchased';
}
